import ReducerConstants from "../../config/ReduxConstant";

const INITIAL_STATE = {
    showCustomTestReports: null,
    customTestReports: {},
    pastCustomTestReports: {},
    errors: {
        customTestReports: null,
        pastCustomTestReports: null
    }
};

export const customTestReport = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ReducerConstants.SHOW_CUSTOM_TEST_REPORTS:
            return {
                ...state,
                showCustomTestReports: action.payload
            };
        case ReducerConstants.SAVE_CUSTOM_TEST_REPORTS:
            return {
                ...state,
                customTestReports: action.payload,
                errors: {
                    ...state.errors,
                    customTestReports: null
                }
            };
        case ReducerConstants.SAVE_PAST_CUSTOM_TEST_REPORTS:
            return {
                ...state,
                pastCustomTestReports: action.payload,
                errors: {
                    ...state.errors,
                    pastCustomTestReports: null
                }
            };
        case ReducerConstants.SET_CUSTOM_TEST_REPORT_ERROR:
            return {
                ...state,
                errors: {
                    ...state.errors,
                    [action.payload.type]: action.payload.error
                }
            };
        case ReducerConstants.CLEAR_CUSTOM_TEST_REPORTS_ERROR:
            return {
                ...state,
                errors: {
                    customTestReports: null,
                    pastCustomTestReports: null
                }
            };
        default:
            return state
    }
}